import axios from 'axios'
import { Category } from '../models/category'

const API_URL = process.env.REACT_APP_API_URL

interface CategoriesResponse {
  data: Category[]
  payload: {
    message: string
    pagination: {
      totalPages: number
      currentPage: number
      pageSize: number
      totalItems: number
    }
    code: number
  }
}

interface CategoryResponse {
  data: Category
  payload: {
    message: string
    code: number
  }
}

export const getCategories = async (page: number, pageSize: number): Promise<CategoriesResponse> => {
  const response = await axios.get(`${API_URL}/tour-categories?page=${page}&size=${pageSize}`)
  return response.data
}

export const getCategory = async (id: string): Promise<CategoryResponse> => {
  const response = await axios.get(`${API_URL}/tour-categories/${id}`)
  return response.data
}

export const createCategory = async (category: Omit<Category, '_id'>): Promise<Category> => {
  const response = await axios.post(`${API_URL}/tour-categories`, category)
  return response.data
}

export const updateCategory = async (id: string, category: Omit<Category, '_id'>): Promise<Category> => {
  const response = await axios.patch(`${API_URL}/tour-categories/${id}`, category)
  return response.data
}

export const deleteCategory = async (id: string): Promise<void> => {
  await axios.delete(`${API_URL}/tour-categories/${id}`)
} 